import React from "react"
import { Link } from "react-router-dom"
import { Button } from "reactstrap"

const NotFound = ({ message, linkText = "Back to Dashboard", linkTo = "/" }) => {
    return (
        <div
            className="d-flex flex-column align-items-center justify-content-center"
            style={{
                minHeight: "60vh",
                textAlign: "center",
                color: "#fff",
                padding: "20px",
            }}
        >
            <div style={{ marginBottom: "20px" }}>
                <i
                    className="fa-solid fa-triangle-exclamation"
                    style={{ fontSize: "48px", color: "#F6255A" }}
                ></i>
            </div>
            <h3 style={{ marginBottom: "10px" }}>This page isn't available</h3>
            <p style={{ color: "#b0b3b8", maxWidth: "400px", marginBottom: "30px" }}>
                {message ||
                    "The link may be broken, or the page may have been removed. Check to see if the link you're trying to open is correct."}
            </p>
            <Link to={linkTo}>
                <Button
                    style={{
                        background: "linear-gradient(135deg, #F6255A 0%, #F6255A 100%)",
                        border: "none",
                        padding: "10px 30px",
                        borderRadius: "8px",
                        fontWeight: "600",
                    }}
                >
                    {linkText}
                </Button>
            </Link>
        </div>
    )
}

export default NotFound
